module.exports = __webpack_public_path__ + "static/img/close.25380350.png";